module.exports = __webpack_public_path__ + "media/zq+qh-cn.352ff1d1.mp3";